var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLinkedinIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.3334 6.66663C14.6595 6.66663 15.9313 7.19341 16.8689 8.13109C17.8066 9.06877 18.3334 10.3405 18.3334 11.6666V17.5H15.0001V11.6666C15.0001 11.2246 14.8245 10.8007 14.5119 10.4881C14.1994 10.1756 13.7754 9.99996 13.3334 9.99996C12.8914 9.99996 12.4675 10.1756 12.1549 10.4881C11.8423 10.8007 11.6667 11.2246 11.6667 11.6666V17.5H8.33342V11.6666C8.33342 10.3405 8.8602 9.06877 9.79788 8.13109C10.7356 7.19341 12.0073 6.66663 13.3334 6.66663Z",
    stroke: "#090A0A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.00008 7.49996H1.66675V17.5H5.00008V7.49996Z",
    stroke: "#090A0A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.33341 4.99996C4.25389 4.99996 5.00008 4.25377 5.00008 3.33329C5.00008 2.41282 4.25389 1.66663 3.33341 1.66663C2.41294 1.66663 1.66675 2.41282 1.66675 3.33329C1.66675 4.25377 2.41294 4.99996 3.33341 4.99996Z",
    stroke: "#090A0A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedinIcon);
export default __webpack_public_path__ + "static/media/linkedin_icon.c466e404398d56d0997c63db808de04e.svg";
export { ForwardRef as ReactComponent };